import React from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { RatePlanListAllModel } from '../../api/pricing/pricing.types';
import {WithTranslation, withTranslation} from 'react-i18next';

interface RatePlanDurationModalProps extends WithTranslation {
  toggle: () => void;
  isOpen: boolean;
  precedingPlan: RatePlanListAllModel | null;
  followingPlan: RatePlanListAllModel | null;
  onPrecedingPlanExtend: (id: number) => void;
  onFollowingPlanExtend: (id: number) => void;
}

class RatePlanDurationModal extends React.PureComponent<RatePlanDurationModalProps> {

  render() {
      const { t } = this.props;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{t('modal_text.rate_plan.extend_rate')}</ModalHeader>
        <ModalBody>
            {t('modal_text.rate_plans.which_rate_plan_to_extend')}
        </ModalBody>
        <ModalFooter>
          { this.props.precedingPlan && (
            <>
              <Button color="primary" onClick={() => this.props.onPrecedingPlanExtend(this.props.precedingPlan ? this.props.precedingPlan.id : 0)}>{t('modal_text.rate_plans.extend_preceding')}</Button>
              {' '}
            </>
          )}
          { this.props.followingPlan && (
            <>
              <Button color="primary" onClick={() => this.props.onFollowingPlanExtend(this.props.followingPlan ? this.props.followingPlan.id : 0)}>{t('modal_text.rate_plans.extend_following')}</Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(RatePlanDurationModal);
